import { ACCOUNT_STATUS_OPTIONS } from "@/utils/customerProfile.js";
import { CUSTOMER_TYPE_FILTER_OPTIONS } from "@/utils/customerListFilters.js";
import FilterToolboxShell from "@/components/FilterToolboxShell.jsx";

export default function CustomerListFilterToolbox({
    filters,
    loading = false,
    onChange,
    onApply,
    onReset
}) {
    return (
        <FilterToolboxShell loading={loading} onApply={onApply} onReset={onReset}>
            <label className="field">
                Recherche
                <input
                    type="search"
                    placeholder="Identifiant, nom ou raison sociale…"
                    value={filters.search}
                    onChange={(e) => onChange({ ...filters, search: e.target.value })}
                />
            </label>

            <label className="field field--status">
                Statut du compte
                <select
                    value={filters.accountStatus}
                    onChange={(e) => onChange({ ...filters, accountStatus: e.target.value })}
                >
                    <option value="">Tous</option>
                    {ACCOUNT_STATUS_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </label>

            <label className="field field--status">
                Type de client
                <select
                    value={filters.customerType}
                    onChange={(e) => onChange({ ...filters, customerType: e.target.value })}
                >
                    {CUSTOMER_TYPE_FILTER_OPTIONS.map((option) => (
                        <option key={option.value || "all"} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </label>
        </FilterToolboxShell>
    );
}
